/* ==========================================================================
   FlatWine — format.js
   Formato de dinero compartido. Vive aparte porque el PDP y el carrito
   lo necesitan igual, y duplicarlo garantiza que se desincronicen.
   Se expone en window porque los scripts de sección se cargan por
   separado y no hay bundler.
   ========================================================================== */

(function (w) {
  'use strict';

  /* Convierte centavos al formato de dinero de la tienda.
     Soporta los marcadores de Shopify con y sin separador de miles. */
  w.fwMoney = function (cents, format) {
    var f = format || '${{amount}}';
    var noDecimals = /amount_no_decimals/.test(f);
    var useComma = /comma_separator/.test(f);

    /* Sin esta guarda, un cents indefinido acababa imprimiéndole «$NaN» al
       cliente en el precio. */
    var n = Number(cents);
    if (!isFinite(n)) {
      console.error('[format] importe no numérico:', cents);
      return '';
    }

    var value = (n / 100).toFixed(noDecimals ? 0 : 2);
    var parts = value.split('.');

    var thousands = useComma ? '.' : ',';
    var decimal = useComma ? ',' : '.';

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return f.replace(/\{\{\s*amount[^}]*\}\}/, parts.join(decimal));
  };
})(window);
